<template>
  <div class="hello-world-container">
    <section class="hero-stage">
      <div class="slider-wrapper">
        <div 
          v-for="(slide, index) in slides" 
          :key="index" 
          class="slide-item" 
          :class="{ 'active-slide': index === currentSlideIndex }"
          :style="{'background-image': 'url(' + require('@/assets/images/' + slide.image) + ')'}"
        >
          <div class="hero-content d-flex align-items-center justify-content-center h-100">
            <div class="hero-panel">
              <div class="hero-badge mb-3">
                <i class="fas fa-sparkles me-1"></i> Plataforma de listas para qualquer evento
              </div>
              <h1 class="display-4 fw-bold">{{ slide.title }}</h1>
              <p class="lead mb-3">{{ slide.subtitle }}</p>

              <div class="hero-tags mb-4">
                <span class="hero-tag">Casamento</span>
                <span class="hero-tag">Aniversário</span>
                <span class="hero-tag">Chá de Bebê</span>
                <span class="hero-tag">Eventos Especiais</span>
              </div>

              <div class="hero-cta-group d-flex justify-content-start gap-3 flex-wrap mt-2">
                <router-link :to="slide.button1Link" class="btn btn-primary btn-lg">
                  {{ slide.button1Text }}
                </router-link>
                <router-link to="/how-it-works" class="btn btn-outline-light btn-lg">
                  Como funciona
                </router-link>
              </div>

              <div class="hero-stats mt-4">
                <div class="hero-stat">
                  <strong>4 etapas</strong>
                  <span>simples e diretas</span>
                </div>
                <div class="hero-stat">
                  <strong>Pix e cartão</strong>
                  <span>para quem presenteia</span>
                </div>
                <div class="hero-stat">
                  <strong>Transferência</strong>
                  <span>direto para sua conta</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    
      <div class="slider-indicators">
        <button 
          v-for="(slide, index) in slides" 
          :key="index" 
          :class="{ 'active': index === currentSlideIndex }" 
          @click="goToSlide(index)"
        ></button>
      </div>
    </section>

    <section class="how-preview">
      <div class="how-preview__header text-center">
        <span class="section-eyebrow">Como Funciona</span>
        <h3 class="how-preview__title">Sua lista em 4 etapas</h3>
      </div>

      <div class="row g-3 mt-1">
        <div class="col-12 col-md-6 col-lg-3" v-for="(step, index) in steps" :key="step.title">
          <article class="how-card h-100 text-center">
            <div class="how-chip mb-3">{{ step.kicker }}</div>
            <div class="how-icon-wrap mx-auto mb-3">
              <i :class="step.icon" class="how-icon"></i>
            </div>
            <h4 class="how-card__title mb-2">{{ step.title }}</h4>
            <p class="how-card__text mb-0">{{ step.text }}</p>
            <div v-if="index < steps.length - 1" class="how-arrow d-none d-lg-flex">
              <i class="fas fa-chevron-right"></i>
            </div>
          </article>
        </div>
      </div>

      <div class="text-center mt-4">
        <router-link to="/how-it-works" class="btn btn-outline-secondary btn-lg">
          Ver guia completo
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {
      currentSlideIndex: 0,
      slides: [
        {
          image: 'hero-slide-1.png',
          title: 'Sua lista de presentes, do seu jeito',
          subtitle: 'Crie uma experiência elegante para casamento, aniversário, chá de bebê ou qualquer celebração especial.',
          button1Text: 'Criar minha lista',
          button1Link: '/my-account/add',
        },
        {
          image: 'hero-slide-2.png',
          title: 'Compartilhe em segundos',
          subtitle: 'Envie seu link para convidados e receba presentes com pagamento simples por Pix ou cartão.',
          button1Text: 'Criar minha lista',
          button1Link: '/my-account/add',
        },
        {
          image: 'hero-slide-3.png',
          title: 'Transforme presentes em liberdade',
          subtitle: 'Acompanhe os valores recebidos e transfira para sua conta com segurança e praticidade.',
          button1Text: 'Criar minha lista',
          button1Link: '/my-account/add',
        }
      ],
      steps: [
        {
          kicker: 'Comece',
          title: 'Crie sua lista',
          text: 'Escolha o tipo de evento e personalize a experiência.',
          icon: 'fa-solid fa-list-check',
        },
        {
          kicker: 'Compartilhe',
          title: 'Envie o link',
          text: 'Compartilhe com amigos e familiares em segundos.',
          icon: 'fa-solid fa-share-nodes',
        },
        {
          kicker: 'Receba',
          title: 'Ganhe presentes',
          text: 'Convidados pagam com praticidade por Pix ou cartão.',
          icon: 'fa-solid fa-gift',
        },
        {
          kicker: 'Finalize',
          title: 'Transfira para sua conta',
          text: 'Com chave Pix cadastrada, transfira o valor disponível.',
          icon: 'fas fa-money-check-alt',
        },
      ],
      slideInterval: null,
    };
  },
  mounted() {
    this.startSlideShow();
  },
  beforeUnmount() {
    this.stopSlideShow();
  },
  methods: {
    startSlideShow() {
      this.slideInterval = setInterval(() => {
        this.nextSlide();
      }, 9000);
    },
    stopSlideShow() {
      clearInterval(this.slideInterval);
    },
    nextSlide() {
      this.currentSlideIndex = (this.currentSlideIndex + 1) % this.slides.length;
    },
    prevSlide() {
      this.currentSlideIndex = (this.currentSlideIndex - 1 + this.slides.length) % this.slides.length;
    },
    goToSlide(index) {
      this.currentSlideIndex = index;
    }
  }
};
</script>

<style scoped>
/* Reset de margem para o título */
h1 {
  margin-bottom: 0.5rem;
}

/* Base do contêiner */
.hello-world-container {
  width: 100%;
}

.hero-stage {
  height: 68vh;
  min-height: 520px;
  max-height: 920px;
  position: relative;
}

/* Estilos do wrapper do slider */
.slider-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.slide-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.slide-item.active-slide {
  opacity: 1;
}

/* Sobreposição escura para legibilidade */
.slide-item::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to top,
    rgba(9, 14, 34, 0.78) 0%,
    rgba(14, 22, 49, 0.55) 45%,
    rgba(0, 0, 0, 0.05) 100%
  );
  z-index: 1;
}

/* Conteúdo do slide */
.hero-content {
  position: relative;
  z-index: 2;
  color: #fff;
  text-align: left;
  padding: 2.2rem 2.8rem;
}

.hero-panel {
  width: min(860px, 100%);
  background: rgba(16, 24, 54, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 1.2rem;
  backdrop-filter: blur(5px);
  padding: 1.95rem 2.1rem;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(6px);
  border: 1px solid rgba(255, 255, 255, 0.35);
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.3rem 1rem;
  border-radius: 2rem;
  letter-spacing: 0.02em;
}

.hero-content h1 {
  font-size: 2.65rem;
  font-weight: 700;
  line-height: 1.15;
  margin-bottom: 0.8rem;
}

.hero-content p {
  font-size: 1.12rem;
  max-width: 760px;
  color: rgba(255, 255, 255, 0.9);
}

.hero-tags {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.hero-tag {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.65rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: 0.76rem;
  font-weight: 600;
}

/* Indicadores de slide */
.slider-indicators {
  position: absolute;
  bottom: 2.4rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  gap: 0.75rem;
}

.slider-indicators button {
  width: 20px;
  height: 6px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.5);
  border: none;
  cursor: pointer;
  transition: width 0.3s, background 0.3s;
}

.slider-indicators button.active {
  width: 36px;
  background: #ff50a3;
  transform: none;
}

/* Estilos dos botões */
.btn-primary {
  background-color: #ff50a3;
  color: #fff;
  border-color: #ff50a3;
  font-weight: 600;
  border-radius: 2rem;
  padding: 0.75rem 2rem;
}

.btn-primary:hover {
  background-color: #e64593;
  border-color: #e64593;
}

.btn-outline-light {
  color: #fff;
  border-color: #fff;
  font-weight: 600;
  border-radius: 2rem;
  padding: 0.75rem 2rem;
}

.btn-outline-light:hover {
  color: #ff50a3;
  background-color: #fff;
}

.hero-cta-group .btn-lg {
  min-width: 210px;
}

.hero-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.95rem;
}

.hero-stat {
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.08);
  border-radius: 0.75rem;
  padding: 0.72rem 0.85rem;
  display: flex;
  flex-direction: column;
}

.hero-stat strong {
  font-size: 0.88rem;
  color: #fff;
}

.hero-stat span {
  font-size: 0.72rem;
  color: rgba(255, 255, 255, 0.8);
}

.how-preview {
  background: #f8f9fa;
  padding: 2rem 1rem 0.5rem;
}

.section-eyebrow {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #ff50a3;
}

.how-preview__title {
  color: #32355d;
  font-size: 1.55rem;
  font-weight: 700;
  margin-top: 0.35rem;
}

.how-card {
  position: relative;
  background: #fff;
  border: 1px solid #f1f1f1;
  border-radius: 1rem;
  padding: 1rem 1rem 1.1rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.how-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff0f7;
  color: #d73084;
  border: 1px solid #ffd4e8;
  border-radius: 999px;
  padding: 0.18rem 0.65rem;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.how-icon-wrap {
  width: 74px;
  height: 74px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fb;
  border: 1px solid #eceef5;
}

.how-icon {
  color: #32355d;
  font-size: 1.35rem;
}

.how-card__title {
  font-size: 1rem;
  font-weight: 700;
  color: #32355d;
}

.how-card__text {
  color: #6c757d;
  font-size: 0.88rem;
  line-height: 1.45;
}

.how-arrow {
  position: absolute;
  right: -12px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #ececec;
  color: #b1b4c0;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  z-index: 2;
}

/* Responsividade para telas menores */
@media (max-width: 768px) {
  .hello-world-container {
    margin-top: -1rem;
  }

  .hero-stage {
    height: 610px;
    min-height: 610px;
    max-height: none;
  }

  .hero-content {
    padding: 1rem;
    text-align: center;
    justify-content: flex-start !important;
    align-items: stretch !important;
  }

  .hero-panel {
    padding: 1rem 0.9rem;
    margin-top: 0.35rem;
  }

  .hero-badge {
    font-size: 0.7rem;
    padding: 0.22rem 0.62rem;
  }

  .hero-content h1 {
    font-size: 1.45rem;
    line-height: 1.2;
  }

  .hero-content p {
    font-size: 0.9rem;
    margin-bottom: 0.85rem !important;
  }

  .hero-tags {
    gap: 0.35rem;
    justify-content: center;
    margin-bottom: 0.9rem !important;
  }

  .hero-tag {
    font-size: 0.68rem;
    padding: 0.2rem 0.5rem;
  }

  .hero-cta-group {
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: center !important;
  }

  .hero-cta-group .btn-lg {
    width: 100%;
    max-width: 100%;
    padding: 0.72rem 0.9rem;
    font-size: 0.9rem;
  }

  .hero-stats {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.45rem;
    text-align: left;
    margin-top: 0.9rem !important;
  }

  .hero-stat {
    padding: 0.45rem 0.6rem;
  }

  .hero-stat strong {
    font-size: 0.8rem;
  }

  .hero-stat span {
    font-size: 0.68rem;
  }

  .slider-indicators {
    bottom: 0.7rem;
    gap: 0.5rem;
  }

  .slider-indicators button {
    width: 16px;
    height: 5px;
  }

  .slider-indicators button.active {
    width: 26px;
  }

  .how-preview {
    padding: 1.2rem 1.25rem 0.5rem;
  }

  .how-preview__title {
    font-size: 1.35rem;
  }
}

</style>